export default __webpack_public_path__ + "static/media/DefaultAvatar.65712475de0674c9f775ae3b64e7c69f.113d50ed.svg";